import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=751d54b6&scoped=true&"
import script from "./orderConfirm.vue?vue&type=script&lang=js&"
export * from "./orderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=751d54b6&scoped=true&lang=scss&"
import style1 from "./orderConfirm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d54b6",
  null
  
)

export default component.exports